/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_2_AInputs */

const en_pc_faq_2_a = /** @type {(inputs: Pc_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The ArtCraft open source projects, including PhotoCraft and the launcher, are developed in public on GitHub under the storytold organisation. PhotoCraft uses MIT or Apache-2.0. The ArtCraft name and logos are trademarks and are not covered by the code license.`)
};

const zh_pc_faq_2_a = /** @type {(inputs: Pc_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。包括 PhotoCraft 和启动器在内的 ArtCraft 开源项目，都在 GitHub 的 storytold 组织下公开开发。PhotoCraft 采用 MIT 或 Apache-2.0 许可证，但 ArtCraft 的名称和标志属于商标，不在代码许可范围内。`)
};

/**
* | output |
* | --- |
* | "Yes. The ArtCraft open source projects, including PhotoCraft and the launcher, are developed in public on GitHub under the storytold organisation. PhotoCraft..." |
*
* @param {Pc_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_2_a = /** @type {((inputs?: Pc_Faq_2_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_2_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_2_a(inputs)
	return zh_pc_faq_2_a(inputs)
});
export { pc_faq_2_a as "pc.faq.2.a" }